export default "__VITE_ASSET__CWjyP1hw__"